"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("../common");

var ItemResponses;

(function (ItemResponses) {
  var ItemsFeedAllResponse =
  /** @class */
  function (_super) {
    __extends(ItemsFeedAllResponse, _super);

    function ItemsFeedAllResponse(items, linkedItems, responses, isDeveloperMode) {
      var _this = _super.call(this, responses, isDeveloperMode) || this;

      _this.items = items;
      _this.linkedItems = linkedItems;
      return _this;
    }

    return ItemsFeedAllResponse;
  }(common_1.BaseKontentResponseArrayDebug);

  ItemResponses.ItemsFeedAllResponse = ItemsFeedAllResponse;

  var ItemsFeedResponse =
  /** @class */
  function (_super) {
    __extends(ItemsFeedResponse, _super);

    function ItemsFeedResponse(items, linkedItems, response, isDeveloperMode) {
      var _this = _super.call(this, response, isDeveloperMode) || this;

      _this.items = items;
      _this.linkedItems = linkedItems;
      _this.continuationTokenHeaderName = 'X-Continuation';
      _this.continuationToken = _this.getContinuationToken(response.headers);
      return _this;
    }

    ItemsFeedResponse.prototype.getContinuationToken = function (headers) {
      var _this = this;

      var header = headers.find(function (m) {
        return m.header.toLowerCase() === _this.continuationTokenHeaderName.toLowerCase();
      });
      return header ? header.value : undefined;
    };

    return ItemsFeedResponse;
  }(common_1.BaseKontentResponseStandardDebug);

  ItemResponses.ItemsFeedResponse = ItemsFeedResponse;

  var ListContentItemsResponse =
  /** @class */
  function (_super) {
    __extends(ListContentItemsResponse, _super);
    /**
     * Response containing multiple item
     * @constructor
     * @param {TItem[]} items - Collection of content items
     * @param {Pagination} pagination - Pagination object
     * @param {IContentItemsContainer} linkedItems - Content items that were processed during request
     */


    function ListContentItemsResponse(items, pagination, linkedItems, response, isDeveloperMode) {
      var _this = _super.call(this, response, isDeveloperMode) || this;

      _this.items = items;
      _this.pagination = pagination;
      _this.linkedItems = linkedItems;
      _this.isEmpty = _this.getIsEmpty();
      _this.lastItem = _this.getLastItem();
      _this.firstItem = _this.getFirstItem();
      return _this;
    }
    /**
     * Flattens linkedItems object to an array
     */


    ListContentItemsResponse.prototype.getLinkedItemsAsArray = function () {
      return Object.values(this.items);
    };

    ListContentItemsResponse.prototype.getIsEmpty = function () {
      if (!this.items) {
        return true;
      }

      return this.items.length === 0;
    };

    ListContentItemsResponse.prototype.getFirstItem = function () {
      if (!this.items) {
        return;
      }

      if (this.items.length < 1) {
        return;
      }

      return this.items[0];
    };

    ListContentItemsResponse.prototype.getLastItem = function () {
      if (!this.items) {
        return;
      }

      if (this.items.length < 1) {
        return;
      }

      return this.items[this.items.length - 1];
    };

    return ListContentItemsResponse;
  }(common_1.BaseKontentResponseStandardDebug);

  ItemResponses.ListContentItemsResponse = ListContentItemsResponse;

  var ViewContentItemResponse =
  /** @class */
  function (_super) {
    __extends(ViewContentItemResponse, _super);
    /**
     * Response containing single item
     * @constructor
     * @param {TItem} item - Returned item
     * @param {IContentItemsContainer} linkedItems - Content items that were processed during request
     */


    function ViewContentItemResponse(item, linkedItems, response, isDeveloperMode) {
      var _this = _super.call(this, response, isDeveloperMode) || this;

      _this.item = item;
      _this.linkedItems = linkedItems;
      _this.isEmpty = _this.getIsEmpty();
      return _this;
    }

    ViewContentItemResponse.prototype.getIsEmpty = function () {
      if (!this.item) {
        return true;
      }

      return false;
    };

    return ViewContentItemResponse;
  }(common_1.BaseKontentResponseStandardDebug);

  ItemResponses.ViewContentItemResponse = ViewContentItemResponse;
})(ItemResponses = exports.ItemResponses || (exports.ItemResponses = {}));